"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var styles_1 = require("../../common/styles");
var utilities_1 = require("../../utilities/utilities");
var appViewContext_1 = tslib_1.__importDefault(require("../appViewContext"));
var GenericWidget_1 = tslib_1.__importDefault(require("./GenericWidget"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", ";\n  margin: 1em 0 0 0;\n"], ["\n  ", ";\n  margin: 1em 0 0 0;\n"])), styles_1.general);
var MaxWidth = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: 0 auto;\n  padding: 0 ", "px;\n  max-width: ", "px;\n"], ["\n  margin: 0 auto;\n  padding: 0 ", "px;\n  max-width: ", "px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.app.padding;
}, function (_a) {
    var theme = _a.theme;
    return theme.app.maxWidth || 1200;
});
var Widgets = /** @class */ (function (_super) {
    tslib_1.__extends(Widgets, _super);
    function Widgets(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWidgets = _this.renderWidgets.bind(_this);
        _this.renderWidget = _this.renderWidget.bind(_this);
        _this.renderHiddenContent = _this.renderHiddenContent.bind(_this);
        _this.renderContentWithBackground = _this.renderContentWithBackground.bind(_this);
        _this.distributeWidgets = _this.distributeWidgets.bind(_this);
        _this.wrapperRef = react_1["default"].createRef();
        return _this;
    }
    Widgets.prototype.componentDidCatch = function (e) {
        console.error('Uncaught error in csm-widgets!', e);
    };
    Widgets.prototype.renderWidget = function (widget, idx) {
        var _a = this.props, override = _a.override, renderEmpty = _a.renderEmpty, renderLink = _a.renderLink;
        var key = "widget_" + widget.type + "_" + idx;
        if (widget.type in override) {
            return (react_1["default"].createElement(react_1["default"].Fragment, { key: key }, override[widget.type](widget)));
        }
        return (react_1["default"].createElement(GenericWidget_1["default"], { key: key, widget: widget, renderLink: renderLink, renderEmpty: renderEmpty, override: override }));
    };
    /**
     * Pole widgetov zredukuje na nove pole, kde budu widgety
     * patriace do zbalovacieho obsahu zaradene do vlastneho
     * vnoreneho pola.
     *
     * Napriklad mame na vstupe pole widgetov:
     *   [w1, w2, w3, w4, w5, w6, w7]
     *
     * kde `w3` je zaciatok zbalovaceho obsahu a `w6` je koniec
     * zbalovacieho obsahu.
     *
     * Funkcia vrati pole widgetov:
     *
     *   [w1, w2, [w3, w4, w5], w7]
     *
     * Widget `w6` nebude sucastou kolekcie widgetov na renderovanie.
     *
     * @param {*} widgets
     * @returns
     */
    Widgets.prototype.distributeWidgets = function (widgets) {
        if (!widgets.length) {
            return [];
        }
        var newWidgets = [];
        var hasEnd = false;
        while (widgets.length && !hasEnd) {
            var w = widgets.shift();
            if (w.type === 'hiddenContent') {
                w.elementId = utilities_1.getRandomString(5);
                newWidgets.push(tslib_1.__spreadArrays([w], this.distributeWidgets(widgets)));
            }
            else if (w.type === 'background') {
                var nextWidgets = widgets.map(function (w, idx) {
                    return { type: w.type, idx: idx };
                });
                /*
                  Podmienka na ošetrenie krajneho prípadu keď background začína
                  vo vnútri hidden contentu ale nemá vyznačený koniec.
        
                  Nastáva to v prípade ak sa "otvorí" background, no vo widgetoch,
                  ktoré sa nachádzajú za ním sa pred uzatvorením hidden contentu
                  nenachádza backgroundEnd widget.
        
                  V tom prípade doplníme backgroundEnd widget pred hiddenContentEnd widget
                  a pozadie nam skonci spolu s hidden contentom.
                */
                if (nextWidgets.some(function (w) { return w.type === 'hiddenContentEnd'; }) &&
                    nextWidgets.filter(function (w) { return w.type === 'hiddenContentEnd'; }).length !==
                        nextWidgets.filter(function (w) { return w.type === 'hiddenContent'; }).length &&
                    !nextWidgets.some(function (w) { return w.type === 'backgroundEnd'; })) {
                    widgets.splice(nextWidgets.filter(function (w) { return w.type === 'hiddenContentEnd'; }).slice(-1)[0]
                        .idx, 0, {
                        type: 'backgroundEnd'
                    });
                }
                w.elementId = utilities_1.getRandomString(5);
                newWidgets.push(tslib_1.__spreadArrays([w], this.distributeWidgets(widgets)));
            }
            else if (w.type === 'hiddenContentEnd' || w.type === 'backgroundEnd') {
                hasEnd = true;
            }
            else {
                newWidgets.push(w);
            }
        }
        return newWidgets;
    };
    Widgets.prototype.renderHiddenContent = function (items, idx) {
        var _this = this;
        var hiddenContentWidget = items[0], widgets = items.slice(1);
        return (react_1["default"].createElement(react_1["default"].Fragment, { key: "collapsible-content-" + hiddenContentWidget.elementId },
            hiddenContentWidget.layout === 'faq' &&
                this.renderWidget(hiddenContentWidget, idx),
            react_1["default"].createElement("div", { id: "collapsible-content-" + hiddenContentWidget.elementId, style: { display: 'none' } }, widgets.map(function (widget, idx) {
                return Array.isArray(widget)
                    ? widget[0].type === 'background'
                        ? _this.renderContentWithBackground(widget, idx)
                        : _this.renderHiddenContent(widget, idx)
                    : _this.renderWidget(widget, hiddenContentWidget.elementId + "_" + idx);
            })),
            hiddenContentWidget.layout === 'readMoreButton' &&
                this.renderWidget(hiddenContentWidget, idx)));
    };
    Widgets.prototype.renderContentWithBackground = function (items) {
        var _this = this;
        var _a;
        var backgroundWidget = items[0], widgets = items.slice(1);
        var picture = (_a = backgroundWidget.picture) === null || _a === void 0 ? void 0 : _a.public_url;
        var backgroundStyle = backgroundWidget.size === 'contain'
            ? {
                backgroundSize: 'contain'
            }
            : {
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            };
        if (backgroundWidget.color) {
            backgroundStyle.backgroundColor = backgroundWidget.color;
        }
        if (backgroundWidget.picture) {
            backgroundStyle.backgroundImage = "url(" + picture + ")";
        }
        return (react_1["default"].createElement(react_1["default"].Fragment, { key: "background-content-" + backgroundWidget.elementId },
            react_1["default"].createElement("div", { id: "background-content-" + backgroundWidget.elementId, style: backgroundStyle, className: 'background-content' }, widgets.map(function (widget, idx) {
                return Array.isArray(widget)
                    ? widget[0].type === 'background'
                        ? _this.renderContentWithBackground(widget, idx)
                        : _this.renderHiddenContent(widget, idx)
                    : _this.renderWidget(widget, backgroundWidget.elementId + "_" + idx);
            }))));
    };
    Widgets.prototype.renderWidgets = function (items) {
        var _this = this;
        var distributed = this.distributeWidgets(utilities_1.transformDeprecatedContent(tslib_1.__spreadArrays(items)));
        return distributed.map(function (widget, idx) {
            return Array.isArray(widget)
                ? widget[0].type === 'background'
                    ? _this.renderContentWithBackground(widget, idx)
                    : _this.renderHiddenContent(widget, idx)
                : _this.renderWidget(widget, idx);
        });
    };
    Widgets.prototype.render = function () {
        var _a = this.props, items = _a.items, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.appSpace, appSpace = _c === void 0 ? '' : _c, _d = _a.appId, appId = _d === void 0 ? '' : _d, _e = _a.contentDivider, contentDivider = _e === void 0 ? '' : _e, _f = _a.accessToken, accessToken = _f === void 0 ? '' : _f;
        return (react_1["default"].createElement(appViewContext_1["default"].Provider, { value: {
                appSpace: appSpace,
                appId: appId,
                contentDivider: contentDivider,
                accessToken: accessToken,
                wrapperRef: this.wrapperRef
            } },
            react_1["default"].createElement(Wrapper, { ref: this.wrapperRef, className: className + " content-widgets" },
                react_1["default"].createElement(MaxWidth, null, this.renderWidgets(items)))));
    };
    return Widgets;
}(react_1.PureComponent));
Widgets.propTypes = {
    override: prop_types_1["default"].objectOf(prop_types_1["default"].func),
    items: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
        type: prop_types_1["default"].string.isRequired
    })),
    renderLink: prop_types_1["default"].func,
    renderEmpty: prop_types_1["default"].func,
    className: prop_types_1["default"].string,
    appSpace: prop_types_1["default"].string,
    appId: prop_types_1["default"].string,
    contentDivider: prop_types_1["default"].string,
    accessToken: prop_types_1["default"].string
};
Widgets.defaultProps = {
    items: [],
    override: {},
    renderLink: undefined,
    renderEmpty: undefined,
    className: undefined
};
exports["default"] = Widgets;
var templateObject_1, templateObject_2;
